exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register[data-v-c770dce8]{padding:0 30px;width:100%;box-sizing:border-box;text-align:center}input[data-v-c770dce8]{border-radius:5px;padding:10px;border:1px solid #ccc;width:100%;margin-top:10px;box-sizing:border-box}.em_btn[data-v-c770dce8]{background:#268e87;width:100%;border-radius:5px;color:#fff;display:block;padding:10px 0;margin:20px 0}.ps[data-v-c770dce8]{font-size:12px;line-height:20px}.ps a[data-v-c770dce8]{text-decoration:underline}.link_login[data-v-c770dce8]{font-size:14px;margin-top:30px}.link_login .to_login[data-v-c770dce8]{color:#268e87}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c770dce8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/register.vue
// module id = 112
// module chunks = 0